import config from "../config";
import { getAuthHeader, sendPostRequest } from "../Utility/FetchUtils";
import { TestParameter } from "../Model/TestingParameter";
import { EResultCode } from "../Model/EResultCode";
export default class TestingApi {
  static BASE_URL = config.SERVICE_URL + "/Testing";

  static doTesting(parameter: TestParameter) {
    const url = this.BASE_URL + "/:run-test";
    return sendPostRequest(url, parameter);
  }

  static async doTestingUseFetch(
    payload: TestParameter
  ): Promise<{ resultCode: EResultCode; description: string }> {
    const url = this.BASE_URL + "/:run-test";
    const response = await fetch(url, {
      method: "POST",
      headers: getAuthHeader(payload),
      body: JSON.stringify(payload),
    });
    const data = await response.json();
    return data;
  }

  static stopTesting() {
    const url = this.BASE_URL + "/:stop-test";
    return sendPostRequest(url);
  }
}
